module.exports = __webpack_public_path__ + "img/psychological.0edf9991.png";